export enum ModalType {
  AVAILABLE_TEMPLATES = 'available_templates',
  COVERAGE_REQUEST = 'coverage_request',
  DELETE_TEMPLATE_CONFIRM = 'delete_template_confirm',
  LOCKED_ORDER = 'locked_order',
  MISSING_CONTACTS_CONFIRM = 'missing_contacts_confirm',
  ORDER_NOTES = 'order_notes',
  REFRESH_DATA_CONFIRM = 'refresh_data_confirm',
  REFRESH_ORDER_APPROVE = 'refresh_order_approve',
  REFRESH_ORDER_RESULT = 'refresh_order_result',
  SESSION_EXPIRED = 'session_expired',
  STATUS_UPDATES = 'status_updates',
  VERIFICATION_PAYMENT = 'verification_payment',
  VOA_FANNIE_FREDDIE_POPUP = 'voa_fannie_freddie_popup',
  BILLING_CONFIRM_PLAN = 'billing_confirm_plan',
}
